module.exports = __webpack_public_path__ + "img/9cf7625.png";